import { Text, TextProps } from '@chakra-ui/react';

/**
 * just a convenience wrapper, because vscode doesn't autocomplete the chakra-ui Text component
 */
export function Txt(props: TextProps) {
  return <Text {...props} />;
}

export function TxtMuted(props: TextProps) {
  return <Txt textStyle="sm" color="fg.muted" {...props} />;
}
